import React from 'react'
import PropTypes from 'prop-types'

import FilterLanguages from 'syft-acp-util/components/FilterForm/FilterLanguages'

const DataLanguageDropdown = ({ value, editable, onChange, enabled }) => (
  <FilterLanguages value={value} enabled={enabled && editable} onChange={onChange} />
)

DataLanguageDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default DataLanguageDropdown
